import { memo } from 'react';
import PropTypes from 'prop-types';

import {
  createServicePlanInvoicePaymentSession,
  payServicePlanInvoiceWithSavedCard,
} from 'api';
import InvoicePayButtonBase from 'components/invoices/invoice-pay-button/base';

function ServicePlanInvoicePayButton({
  invoiceId,
  portalId,
  totalAmount,
  tipBaseAmount,
  invoiceSettingsOverride,
  creditToBeApplied,
  ...restProps
}) {
  return (
    <InvoicePayButtonBase
      invoiceId={invoiceId}
      portalId={portalId}
      totalAmount={totalAmount}
      tipBaseAmount={tipBaseAmount}
      invoiceSettingsOverride={invoiceSettingsOverride}
      creditToBeApplied={creditToBeApplied}
      createPaymentSessionAction={createServicePlanInvoicePaymentSession}
      payWithSavedCardAction={payServicePlanInvoiceWithSavedCard}
      redirectUrl={`/${portalId}/invoices/${invoiceId}?type=service-plan&stripe_result=success`}
      invalidateQueriesOnSkippedPayment={[
        'invoicesListingQuery',
        `invoice-${invoiceId}`,
        `service-plan-invoice-${invoiceId}`,
      ]}
      {...restProps}
    />
  );
}

ServicePlanInvoicePayButton.propTypes = {
  invoiceId: PropTypes.string.isRequired,
  portalId: PropTypes.string.isRequired,
  totalAmount: PropTypes.number.isRequired,
  tipBaseAmount: PropTypes.number,
  invoiceSettingsOverride: PropTypes.shape({
    ccSurchargeOverride: PropTypes.shape({
      enabled: PropTypes.bool.isRequired,
    }),
  }),
  creditToBeApplied: PropTypes.number,
};

ServicePlanInvoicePayButton.defaultProps = {
  tipBaseAmount: null,
  invoiceSettingsOverride: null,
  creditToBeApplied: 0,
};

export default memo(ServicePlanInvoicePayButton);
